import { CSSProperties } from "react";

export default function VehicleStand({
  className,
  style,
}: {
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <svg
      width="266"
      height="70"
      viewBox="0 0 266 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <mask
        id="mask0_1641_130453"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="266"
        height="70"
      >
        <rect width="266" height="70" fill="url(#paint0_linear_1641_130453)" />
      </mask>
      <g mask="url(#mask0_1641_130453)">
        <path
          d="M243.525 35C243.525 36.2573 242.853 37.5493 241.43 38.8651C240.007 40.1802 237.881 41.4724 235.096 42.7177C229.529 45.2069 221.444 47.4607 211.413 49.358C191.36 53.1508 163.636 55.5 132.999 55.5C102.361 55.5 74.6372 53.1508 54.5844 49.358C44.5539 47.4607 36.468 45.2069 30.9018 42.7177C28.1169 41.4724 25.9905 40.1802 24.5677 38.8651C23.1443 37.5493 22.4727 36.2573 22.4727 35C22.4727 33.7427 23.1443 32.4507 24.5677 31.1349C25.9905 29.8198 28.1169 28.5276 30.9018 27.2823C36.468 24.7931 44.5539 22.5393 54.5844 20.642C74.6372 16.8492 102.361 14.5 132.999 14.5C163.636 14.5 191.36 16.8492 211.413 20.642C221.444 22.5393 229.529 24.7931 235.096 27.2823C237.881 28.5276 240.007 29.8198 241.43 31.1349C242.853 32.4507 243.525 33.7427 243.525 35Z"
          stroke="#1F1F1F"
        />
        <path
          d="M233.118 35C233.118 35.7076 232.597 36.5208 231.292 37.408C230.008 38.281 228.082 39.1428 225.554 39.9745C220.505 41.6356 213.172 43.139 204.079 44.4043C185.9 46.9337 160.769 48.5 133 48.5C105.231 48.5 80.1009 46.9337 61.9219 44.4043C52.8286 43.139 45.4955 41.6356 40.4461 39.9745C37.918 39.1428 35.9921 38.281 34.7081 37.408C33.4033 36.5208 32.8828 35.7076 32.8828 35C32.8828 34.2924 33.4033 33.4792 34.7081 32.592C35.9921 31.719 37.918 30.8572 40.4461 30.0255C45.4955 28.3644 52.8286 26.861 61.9219 25.5957C80.1009 23.0663 105.231 21.5 133 21.5C160.769 21.5 185.9 23.0663 204.079 25.5957C213.172 26.861 220.505 28.3644 225.554 30.0255C228.082 30.8572 230.008 31.719 231.292 32.592C232.597 33.4792 233.118 34.2924 233.118 35Z"
          stroke="#1F1F1F"
        />
        <path
          d="M255.093 35C255.093 36.7746 254.308 38.5481 252.73 40.3093C251.149 42.0735 248.795 43.7993 245.721 45.4589C239.575 48.7779 230.648 51.7824 219.575 54.3115C197.437 59.368 166.828 62.5 133.001 62.5C99.1748 62.5 68.5661 59.368 46.4277 54.3115C35.3544 51.7824 26.4277 48.7779 20.2816 45.4589C17.2081 43.7993 14.8538 42.0735 13.2732 40.3093C11.6953 38.5481 10.9102 36.7746 10.9102 35C10.9102 33.2254 11.6953 31.4519 13.2732 29.6907C14.8538 27.9265 17.2081 26.2007 20.2816 24.5411C26.4277 21.2221 35.3544 18.2176 46.4277 15.6885C68.5661 10.632 99.1748 7.5 133.001 7.5C166.828 7.5 197.437 10.632 219.575 15.6885C230.648 18.2176 239.575 21.2221 245.721 24.5411C248.795 26.2007 251.149 27.9265 252.73 29.6907C254.308 31.4519 255.093 33.2254 255.093 35Z"
          stroke="#1F1F1F"
        />
        <path
          d="M265.5 35C265.5 39.5591 261.981 44.0327 255.284 48.199C248.614 52.3488 238.93 56.1042 226.918 59.2652C202.902 65.5852 169.697 69.5 133 69.5C96.3032 69.5 63.098 65.5852 39.082 59.2652C27.0704 56.1042 17.3858 52.3488 10.7159 48.199C4.01948 44.0327 0.5 39.5591 0.5 35C0.5 30.4409 4.01948 25.9673 10.7159 21.801C17.3858 17.6512 27.0704 13.8958 39.082 10.7348C63.098 4.41481 96.3032 0.5 133 0.5C169.697 0.5 202.902 4.41481 226.918 10.7348C238.93 13.8958 248.614 17.6512 255.284 21.801C261.981 25.9673 265.5 30.4409 265.5 35Z"
          stroke="#1F1F1F"
        />
        <mask
          id="mask1_1641_130453"
          // style="mask-type:alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="266"
          height="70"
        >
          <rect width="266" height="70" fill="url(#paint1_linear_1641_130453)" />
        </mask>
        <g mask="url(#mask1_1641_130453)">
          <path
            d="M243.525 35C243.525 36.2573 242.853 37.5493 241.43 38.8651C240.007 40.1802 237.881 41.4724 235.096 42.7177C229.529 45.2069 221.444 47.4607 211.413 49.358C191.36 53.1508 163.636 55.5 132.999 55.5C102.361 55.5 74.6372 53.1508 54.5844 49.358C44.5539 47.4607 36.468 45.2069 30.9018 42.7177C28.1169 41.4724 25.9905 40.1802 24.5677 38.8651C23.1443 37.5493 22.4727 36.2573 22.4727 35C22.4727 33.7427 23.1443 32.4507 24.5677 31.1349C25.9905 29.8198 28.1169 28.5276 30.9018 27.2823C36.468 24.7931 44.5539 22.5393 54.5844 20.642C74.6372 16.8492 102.361 14.5 132.999 14.5C163.636 14.5 191.36 16.8492 211.413 20.642C221.444 22.5393 229.529 24.7931 235.096 27.2823C237.881 28.5276 240.007 29.8198 241.43 31.1349C242.853 32.4507 243.525 33.7427 243.525 35Z"
            stroke="var(--brand-color)"
          />
          <path
            d="M233.118 35C233.118 35.7076 232.597 36.5208 231.292 37.408C230.008 38.281 228.082 39.1428 225.554 39.9745C220.505 41.6356 213.172 43.139 204.079 44.4043C185.9 46.9337 160.769 48.5 133 48.5C105.231 48.5 80.1009 46.9337 61.9219 44.4043C52.8286 43.139 45.4955 41.6356 40.4461 39.9745C37.918 39.1428 35.9921 38.281 34.7081 37.408C33.4033 36.5208 32.8828 35.7076 32.8828 35C32.8828 34.2924 33.4033 33.4792 34.7081 32.592C35.9921 31.719 37.918 30.8572 40.4461 30.0255C45.4955 28.3644 52.8286 26.861 61.9219 25.5957C80.1009 23.0663 105.231 21.5 133 21.5C160.769 21.5 185.9 23.0663 204.079 25.5957C213.172 26.861 220.505 28.3644 225.554 30.0255C228.082 30.8572 230.008 31.719 231.292 32.592C232.597 33.4792 233.118 34.2924 233.118 35Z"
            stroke="var(--brand-color)"
          />
          <path
            d="M255.093 35C255.093 36.7746 254.308 38.5481 252.73 40.3093C251.149 42.0735 248.795 43.7993 245.721 45.4589C239.575 48.7779 230.648 51.7824 219.575 54.3115C197.437 59.368 166.828 62.5 133.001 62.5C99.1748 62.5 68.5661 59.368 46.4277 54.3115C35.3544 51.7824 26.4277 48.7779 20.2816 45.4589C17.2081 43.7993 14.8538 42.0735 13.2732 40.3093C11.6953 38.5481 10.9102 36.7746 10.9102 35C10.9102 33.2254 11.6953 31.4519 13.2732 29.6907C14.8538 27.9265 17.2081 26.2007 20.2816 24.5411C26.4277 21.2221 35.3544 18.2176 46.4277 15.6885C68.5661 10.632 99.1748 7.5 133.001 7.5C166.828 7.5 197.437 10.632 219.575 15.6885C230.648 18.2176 239.575 21.2221 245.721 24.5411C248.795 26.2007 251.149 27.9265 252.73 29.6907C254.308 31.4519 255.093 33.2254 255.093 35Z"
            stroke="var(--brand-color)"
          />
          <path
            d="M265.5 35C265.5 39.5591 261.981 44.0327 255.284 48.199C248.614 52.3488 238.93 56.1042 226.918 59.2652C202.902 65.5852 169.697 69.5 133 69.5C96.3032 69.5 63.098 65.5852 39.082 59.2652C27.0704 56.1042 17.3858 52.3488 10.7159 48.199C4.01948 44.0327 0.5 39.5591 0.5 35C0.5 30.4409 4.01948 25.9673 10.7159 21.801C17.3858 17.6512 27.0704 13.8958 39.082 10.7348C63.098 4.41481 96.3032 0.5 133 0.5C169.697 0.5 202.902 4.41481 226.918 10.7348C238.93 13.8958 248.614 17.6512 255.284 21.801C261.981 25.9673 265.5 30.4409 265.5 35Z"
            stroke="var(--brand-color)"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1641_130453"
          x1="133"
          y1="-27.5"
          x2="133"
          y2="70"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#D9D9D9" stopOpacity="0" />
          <stop offset="0.5" stopColor="#A9A9A9" stopOpacity="0.5" />
          <stop offset="1" stopColor="#737373" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1641_130453"
          x1="181.75"
          y1="21.25"
          x2="84.25"
          y2="21.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#D9D9D9" stopOpacity="0" />
          <stop offset="0.5" stopColor="#A9A9A9" stopOpacity="0.5" />
          <stop offset="1" stopColor="#737373" />
        </linearGradient>
      </defs>
    </svg>
  );
}
